import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';
import {
  LmsCurriculumMode,
  LmsCurriculumUserStatus,
} from 'src/graphql/generated/graphql';

type GetFilterConfigProps = {
  t: TFunction;
  isAdmin: boolean;
};

export const getFilterConfig = ({ t, isAdmin }: GetFilterConfigProps) => [
  {
    id: 'mode',
    size: 2,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('lms.curriculum.list.filter.mode'),
        variant: 'outlined',
        name: 'mode',
        label: t('lms.curriculum.list.filter.mode'),
      },
      options: [
        {
          value: LmsCurriculumMode.SelfPacedOnline,
          name: t('lms.curriculum.list.columns.mode.self-paced'),
        },
        {
          value: LmsCurriculumMode.VirtualInstructor,
          name: t('lms.curriculum.list.columns.mode.virtual-instructor'),
        },
        {
          value: LmsCurriculumMode.InPerson,
          name: t('lms.curriculum.list.columns.mode.in-person'),
        },
      ],
    },
  },
  ...(!isAdmin
    ? [
        {
          id: 'userCurriculumStatus',
          size: 2,
          type: FilterItemType.Select,
          props: {
            inputProps: {
              placeholder: t('common.status-label'),
              variant: 'outlined',
              name: 'userCurriculumStatus',
              label: t('common.status-label'),
            },
            options: [
              {
                value: LmsCurriculumUserStatus.InProgress,
                name: t('common.status.in-progress'),
              },
              {
                value: LmsCurriculumUserStatus.Assigned,
                name: t('common.status.available'),
              },
              {
                value: LmsCurriculumUserStatus.Completed,
                name: t('common.status.completed'),
              },
            ],
          },
        },
      ]
    : []),
  ...(isAdmin
    ? [
        {
          id: 'externalId',
          size: 2,
          type: FilterItemType.Input,
          props: {
            placeholder: t('lms.curriculum.list.filter.external-id'),
            name: 'externalId',
            label: t('lms.curriculum.list.filter.external-id'),
            fullWidth: true,
          },
        },
      ]
    : []),
];
